declare global {
  interface Window {
    dataLayer: any[];
  }
}

export function pushDataLayer(eventName: string, payload?: Record<string, any>) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...payload });
  }
}